module.exports = __webpack_public_path__ + "static/implant-after-c96b760e6272977cbabee8de0b5ea0d8.jpg";